import { produce } from 'immer';
import {
  BOOKMARK_COURSES_GET,
  BOOKMARK_DOCUMENTS_GET,
  BOOKMARK_EVENTS_GET,
  BOOKMARK_MODULES_GET,
} from '../actions/bookmarks';
import { AUTH_LOGOUT } from '../actions';

const initialState = {
  courses: {
    filters: {},
    list: [],
    pager: {},
  },
  modules: {
    filters: {},
    list: [],
    pager: {},
  },
  events: {
    filters: {},
    list: [],
    pager: {},
  },
  documents: {
    filters: {},
    list: [],
    pager: {},
  },
};

const bookmarksReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case BOOKMARK_COURSES_GET._SUCCESS: {
        const { data, pager } = action;
        draft.courses.list = data?.items || [];
        draft.courses.filters = {
          ...state.courses.filters,
          ...(data?.filters || {}),
        };
        draft.courses.pager = pager;
        break;
      }

      case BOOKMARK_MODULES_GET._SUCCESS: {
        const { data, pager } = action;
        draft.modules.list = data?.items || [];
        draft.modules.filters = {
          ...state.modules.filters,
          ...(data?.filters || {}),
        };
        draft.modules.pager = pager;
        break;
      }

      case BOOKMARK_EVENTS_GET._SUCCESS: {
        const { data, pager } = action;
        draft.events.list = data?.items || [];
        draft.events.filters = {
          ...state.events.filters,
          ...(data?.filters || {}),
        };
        draft.events.pager = pager;
        break;
      }

      case BOOKMARK_DOCUMENTS_GET._SUCCESS: {
        const { data, pager } = action;
        draft.documents.list = data?.items || [];
        draft.documents.filters = {
          ...state.documents.filters,
          ...(data?.filters || {}),
        };
        draft.documents.pager = pager;
        break;
      }
      default:
        return state;
    }
    return draft;
  });

export default bookmarksReducer;
